export enum LocationWithIssueType {
  NO_ACTIVE_RETURN_CODE = 'NO_ACTIVE_RETURN_CODE',
  NO_RETURNS_IN_PAST_30_DAYS = 'NO_RETURNS_IN_PAST_30_DAYS',
  RETURN_CODE_USAGE_HAS_DECLINED_SHARPLY = 'RETURN_CODE_USAGE_HAS_DECLINED_SHARPLY',
}
